import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonos, FOCUS_IMAGE } from '../data/content';
export function Bonuses() {
  return <section className="w-full py-12 sm:py-16" aria-labelledby="bonos-title" data-id="element-22" data-mp="av370wfflb2q">
      <div className="mx-auto max-w-6xl px-6" data-id="element-23" data-mp="asz5gl508o5m">
        <div className="grid items-start gap-8 lg:grid-cols-[0.9fr_1.1fr]" data-id="element-24" data-mp="ftegh61tdjkf">
          <div className="lg:sticky lg:top-16" data-id="element-25" data-mp="1ueuy79llksh">
            <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-oliva" data-id="element-26" data-mp="1tlpraqaf3cg">
              Bonos incluidos
            </p>
            <h2 id="bonos-title" className="font-display text-3xl font-semibold tracking-tight text-tinta sm:text-4xl" data-id="element-27" data-mp="5tnnx9wtdemz">
              5 bonos para entrenar tu mente todos los días
            </h2>
            <img src={FOCUS_IMAGE} alt="Manos de una jugadora apoyadas sobre el palo de hockey" className="mt-6 hidden w-full rounded-4xl object-cover lg:block" data-id="element-28" data-mp="1m9ysb18l2as9" />
          </div>

          <ul className="space-y-5" data-id="element-29" data-mp="3iclmzqn9ggxa">
            {bonos.map((bono, index) => <motion.li key={bono.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.4,
            delay: index * 0.06
          }} className="overflow-hidden rounded-4xl border border-salvia/40 bg-white shadow-soft" data-id="element-30" data-mp="3dek5391kmnne" data-mpi={index}>
                <div className="relative h-44 w-full overflow-hidden sm:h-52" data-id="element-31" data-mp="2uhsleyi4a6it">
                  <img src={bono.image} alt={`Vista previa del bono ${index + 1}: ${bono.title}`} className="h-full w-full object-cover object-top" data-id="element-32" data-mp="38giiwf8um87p" />
                  <span aria-hidden="true" className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-white via-white/70 to-transparent" data-id="element-33" data-mp="nogjdhb05xy9" />
                </div>

                <div className="flex items-start gap-4 px-7 pb-7 pt-1" data-id="element-34" data-mp="3hhr9zrmzf839">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-agua/25 text-bosque" data-id="element-35" data-mp="3hk3w8gzrw4m4">
                    <GiftIcon className="h-5 w-5" strokeWidth={1.6} aria-hidden="true" data-id="element-36" data-mp="3qiflofowkwcz" />
                  </span>
                  <span data-id="element-37" data-mp="2xtqtj65ts1dd">
                    <span className="block text-xs font-semibold uppercase tracking-[0.16em] text-oliva" data-id="element-38" data-mp="2xv1yvaex5h6l">
                      Bono {index + 1}
                    </span>
                    <span className="mt-1 block font-display text-lg font-semibold leading-snug text-tinta" data-id="element-39" data-mp="37jjvdfg6124f">
                      {bono.title}
                    </span>
                  </span>
                </div>
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}